/**
 * pdp-height-swatches.js
 * PDP Height selector from StoreKit variant-groups.heights
 */
(function () {
  "use strict";

  if (window.__pdpHeightSwatches) {
    window.__pdpHeightSwatches.init();
    return;
  }

  var requestCache = window.__pdpHeightSwatchesCache || (window.__pdpHeightSwatchesCache = {});

  function stopEvent(e) {
    e.preventDefault();
    e.stopPropagation();
  }

  function getMountConfig(el) {
    return {
      productId: el.getAttribute("data-product-id") || "",
      apiBase: el.getAttribute("data-api-base") || "",
      shop: el.getAttribute("data-shop") || "",
    };
  }

  function fetchHeights(cfg) {
    var key = [cfg.apiBase, cfg.shop, cfg.productId].join("|");
    if (!requestCache[key]) {
      var url =
        cfg.apiBase +
        "/variant-groups?productId=" +
        encodeURIComponent(cfg.productId) +
        "&shop=" +
        encodeURIComponent(cfg.shop);

      requestCache[key] = fetch(url, { credentials: "omit" })
        .then(function (res) {
          if (!res.ok) throw new Error("variant-groups request failed: " + res.status);
          return res.json();
        })
        .catch(function (err) {
          delete requestCache[key];
          throw err;
        });
    }
    return requestCache[key];
  }

  function getHeightItems(heights) {
    if (!heights || !heights.items || !heights.items.length) return [];
    return heights.items;
  }

  function isHeightActive(item, heights) {
    if (item.active) return true;
    if (heights && heights.current && item.name) {
      return String(item.name).toLowerCase() === String(heights.current).toLowerCase();
    }
    return false;
  }

  function getHeightItemDesc(item) {
    return item.desc || item.description || item.subtitle || "";
  }

  function buildHeightSwatch(item, heights) {
    var active = isHeightActive(item, heights);
    var itemDesc = getHeightItemDesc(item);
    var link = document.createElement("a");
    link.href = "/products/" + item.handle;
    link.className = "vs-height" + (active ? " vs-height--active" : "");
    if (itemDesc) link.className += " vs-height--has-desc";
    var labelText = item.name || "Height";
    if (itemDesc) labelText += " — " + itemDesc;
    link.title = labelText;
    link.setAttribute("role", "radio");
    link.setAttribute("aria-checked", active ? "true" : "false");
    link.setAttribute("aria-label", labelText);
    if (active) {
      link.setAttribute("aria-current", "page");
      link.addEventListener("click", stopEvent);
    }

    var name = document.createElement("span");
    name.className = "vs-height__label";
    name.textContent = item.name || "";
    link.appendChild(name);

    if (itemDesc) {
      var desc = document.createElement("span");
      desc.className = "vs-height__desc";
      desc.textContent = itemDesc;
      link.appendChild(desc);
    }
    return link;
  }

  function buildHeightsGroup(heights) {
    var items = getHeightItems(heights);
    var wrapper = document.createElement("div");
    wrapper.className =
      "vs-height-group vs-height-group--boxes vs-height-group--count-" +
      Math.min(items.length, 5);
    wrapper.setAttribute("role", "group");
    wrapper.setAttribute("aria-label", "Height options");

    var head = document.createElement("div");
    head.className = "vs-height-group__head";
    var label = document.createElement("span");
    label.className = "vs-height-group__label";
    label.textContent = "Height:";
    var current = document.createElement("span");
    current.className = "vs-height-group__current";
    current.textContent = " " + (heights.current || "");
    head.appendChild(label);
    head.appendChild(current);
    wrapper.appendChild(head);

    var track = document.createElement("div");
    track.className = "vs-height-group__track";
    track.setAttribute("role", "radiogroup");
    track.setAttribute("aria-label", "Select height");
    items.forEach(function (item) {
      track.appendChild(buildHeightSwatch(item, heights));
    });
    wrapper.appendChild(track);
    return wrapper;
  }

  function render(mountEl, payload) {
    var heights = payload && payload.heights;
    var items = getHeightItems(heights);
    mountEl.innerHTML = "";
    if (items.length > 1) {
      mountEl.appendChild(buildHeightsGroup(heights));
    }
  }

  function init() {
    var root = document.getElementById("pdp-height-swatches-root");
    if (!root) return;
    if (root.dataset.vsInitialized === "true" && root.querySelector(".vs-height-group")) return;
    if (root.dataset.vsInitialized === "pending") return;

    var cfg = getMountConfig(root);
    if (!cfg.productId || !cfg.apiBase || !cfg.shop) return;

    root.dataset.vsInitialized = "pending";
    fetchHeights(cfg)
      .then(function (payload) {
        if (!payload) return;
        render(root, payload);
        root.dataset.vsInitialized = "true";
      })
      .catch(function (err) {
        root.dataset.vsInitialized = "false";
        if (window.console) console.error("[pdp-height-swatches]", err);
      });
  }

  window.__pdpHeightSwatches = { init: init };

  init();
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { once: true });
  }
  window.addEventListener("pageshow", init);
})();
